import React from "react";
import { ImageWrapper, BodyTitleContainer, SectionDivider, Container, Skills, SkillsContainer, SkillsSubContainer, Title, BodyTitle, Body, Span } from "./AboutMeStyles";
import { FaAws } from 'react-icons/fa'
import { BsDot } from 'react-icons/bs'
import { SiAudacity } from 'react-icons/si'
import { CgCPlusPlus } from 'react-icons/cg'
import { DiAws, DiCss3, DiCssdeck, DiDart, DiDocker, DiGit, DiHtml5, DiJavascript, DiJavascript1, DiPython, DiReact, DiSwift, DiVisualstudio } from 'react-icons/di';
import { motion } from "framer-motion";

const AboutMe = () => (
    <div style={{  }} id="about">
        <motion.div initial={{opacity: 0, y: 100}} animate={{opacity: 1, y: 0}} transition={{duration: 1}} >
        <SectionDivider />
        <Container style={{ }}>
            <Title>About Me</Title>
            <Body>I'm an international student studying Mechatronic Systems Engineering at Simon Fraser University. I'm currently doing an internship at Novax Corporation as an Electrical Engineer and have previously worked as a part-time Sales Assosciate at Bed Bath and Beyond. Apart from my interests in engineering and software development, I have a knack for automobile manufacturing and design and have done various projects core to mechanical, electrical and systems engineering. Being a fitness enthusiast, a music artist and leading an organized lifestyle are key to my personality.</Body>
            <SkillsContainer >

                <SkillsSubContainer style={{ border: '1px solid white', borderRadius: '10px' }}>
                <div>
                    <BodyTitleContainer>
                        <BodyTitle style={{ marginBottom: '15px' }}>Languages</BodyTitle>
                    </BodyTitleContainer>
                    <Skills>
                        <ImageWrapper><DiPython/></ImageWrapper>
                        <Span>Python</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><CgCPlusPlus/></ImageWrapper>
                        <Span>C++ / C</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiJavascript1/></ImageWrapper>
                        <Span>JavaScript</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiSwift/></ImageWrapper>
                        <Span>Swift</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiDart/></ImageWrapper>
                        <Span>Dart</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiHtml5/></ImageWrapper>
                        <Span>HTML</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiReact/></ImageWrapper>
                        <Span>React</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiCss3/></ImageWrapper>
                        <Span>CSS</Span>
                    </Skills>
                </div>
                </SkillsSubContainer>

                <SkillsSubContainer style={{ border: '1px solid white', borderRadius: '10px' }}>
                <div>
                    <BodyTitleContainer>
                        <BodyTitle style={{ marginBottom: '15px' }}>Technologies</BodyTitle>
                    </BodyTitleContainer>
                    <Skills>
                        <ImageWrapper><DiVisualstudio/></ImageWrapper>
                        <Span>Visual Studio</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiGit/></ImageWrapper>
                        <Span>Git</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><DiDocker/></ImageWrapper>
                        <Span>Docker</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><FaAws/></ImageWrapper>
                        <Span>AWS</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><SiAudacity/></ImageWrapper>
                        <Span>Audacity</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot/></ImageWrapper>
                        <Span>RobotC</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot/></ImageWrapper>
                        <Span>LtSpice</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot/></ImageWrapper>
                        <Span>MATLAB & <br /> Simulink</Span>
                    </Skills>
                </div>
                </SkillsSubContainer>

                <SkillsSubContainer style={{ border: '1px solid white', borderRadius: '10px' }}>
                <div>
                    <BodyTitleContainer>
                        <BodyTitle style={{ marginBottom: '15px' }}>Electrical</BodyTitle>
                    </BodyTitleContainer>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>PCB Design</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Arduino <br/> Arduino IDE</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Servomotors, <br /> Ultrasonic & <br /> Color Sensors</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Soldering</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Circuit <br /> Assembly</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Oscilloscopes</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Microcontroller <br /> Programming</Span>
                    </Skills>
                </div>
                </SkillsSubContainer>

                <SkillsSubContainer style={{ border: '1px solid white', borderRadius: '10px' }}>
                <div>
                    <BodyTitleContainer>
                        <BodyTitle style={{ marginBottom: '15px' }}>Mechanical</BodyTitle>
                    </BodyTitleContainer>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Solidworks & <br /> 3D Printing</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Dynamic <br />Motion <br /> Assemblies</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Stress/Strain <br /> Assemblies</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>Kinematics & <br /> Dynamics</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>CES Granta <br /> EduPack</Span>
                    </Skills>
                    <Skills>
                        <ImageWrapper><BsDot /></ImageWrapper>
                        <Span>2D Engineering <br /> Drawings</Span>
                    </Skills>
                </div>
                </SkillsSubContainer>

            </SkillsContainer>
        </Container>
        </motion.div>
    </div>
);

export default AboutMe;